export default __webpack_public_path__ + "static/media/out3.1a81d3f3.mp3";